/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1OrderLineJob } from '../models/V1OrderLineJob';
import { HttpFile } from '../http/http';

export class V1ListOrderLineJobsResponse {
    /**
    * The list of Order Line Jobs.
    */
    'orderLineJobs'?: Array<V1OrderLineJob>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineJobs",
            "baseName": "order_line_jobs",
            "type": "Array<V1OrderLineJob>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListOrderLineJobsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

